import { logger } from '@automata/utils';
import {
  ActionTaskInput,
  CodeTaskInput,
  ConditionalInput,
  ContinuousLoadingInput,
  DataConnectorInput,
  RepeatedTaskListInput,
  isConditionalInput,
  isContinuousLoadingInput,
  isRepeatedTaskListInput,
} from '@automata/wfb-api';
import { TableCell, TableRow } from '@mui/material';

type TaskType =
  | ActionTaskInput
  | CodeTaskInput
  | DataConnectorInput
  | ConditionalInput
  | RepeatedTaskListInput
  | ContinuousLoadingInput;

type Props = {
  allTasks: Record<string, TaskType>;
  task: TaskType;
};

const getTaskId = (taskId: string | { base: string }): string =>
  typeof taskId === 'string' ? taskId : taskId.base;

export const TaskRow = ({ allTasks, task }: Props): JSX.Element | null => {
  if (isConditionalInput(task)) {
    return (
      <TableRow>
        <TableCell padding="none">{task.id}</TableCell>
        <TableCell>(Conditional)</TableCell>
      </TableRow>
    );
  }

  if (isContinuousLoadingInput(task)) {
    return (
      <TableRow>
        <TableCell padding="none">{task.id}</TableCell>
        <TableCell>(Continuous Loading)</TableCell>
      </TableRow>
    );
  }

  if (isRepeatedTaskListInput(task)) {
    logger.error('RepeatedTaskListInput is not supported');
    return null;
  }

  return (
    <TableRow>
      <TableCell padding="none">{task.id}</TableCell>
      <TableCell>{task.description}</TableCell>
      <TableCell>
        {task.dependencies
          ?.map((id) => {
            const taskDependency = allTasks[getTaskId(id)];

            if (!taskDependency) return null;

            if (
              'description' in taskDependency &&
              !isRepeatedTaskListInput(taskDependency) &&
              !isContinuousLoadingInput(taskDependency)
            ) {
              return taskDependency.dependencies;
            } else {
              // NOTE(IL, 2024-09-27): ConditionalInput has no description
              return getTaskId(taskDependency.id);
            }
          })
          .join(', ')}
      </TableCell>
    </TableRow>
  );
};
